import React from "react";
import styles from "./TextField.module.css"
import {useAppDispatch} from "../../../app/hooks";
import {openPopupModal, PopupModalName} from "../popupModalProvider/popupModalSlice";

interface TextFieldProps {
    title: string
    value: any
}

export const TextField: React.FC<TextFieldProps> = ({
                                                        title,
                                                        value
                                                    }) => {
    const dispatch = useAppDispatch();
    const MAX_VALUE_LENGTH = 180;
    const isLongStringValue = typeof value === "string" && value.length > MAX_VALUE_LENGTH;
    const preparedValue = isLongStringValue ? `${value.substring(0, MAX_VALUE_LENGTH)}...` : value ?? "—";

    const handleViewMore = () => {
        dispatch(openPopupModal({
            name: PopupModalName.VIEW_MORE,
            popupModalProps: {
                title,
                value
            }
        }))
    }

    return <div className={styles.wrapper}>
        <span className={styles.title}>{title}</span>
        <div className={styles.valueWrapper}>
            <span className={styles.value}>{preparedValue}</span>
            {isLongStringValue && <span className={styles.viewMore} onClick={handleViewMore}>View more</span>}
        </div>
    </div>
}
